export default {
      id: "kiosque_ecouter-usage",
      viewBox: "0 0 43 43",
      url: "../dist/images/" + "sprite.svg#kiosque_ecouter-usage",
      toString: function () {
        return this.url;
      }
    }